import React from 'react'
import Header from "../component/Header";
import Footer from "../component/Footer"
// import logo from "../images/logo.png";
import image19 from "../images/image19.png";
import image18 from "../images/image18.png"; import image17 from "../images/image17.png";
import image16 from "../images/image16.png";
import image15 from "../images/image15.png";
import image20 from "../images/image20.png";
import image6 from "../images/image6.png";
import image7 from "../images/image7.png";
import image3 from "../images/image3.png";
import image14 from "../images/image14.png";
import SONIA from "../images/SONIA.JPG";


function Home() {
  const style = { color: "#FFFFFF", width: "68px", height: "18px", position: "absolute", top: "20px", left: "24px", right: "280px", bottom: "23px" }
  return (
    <>
      <div className="container">
        <Header />
        {/* <img src={logo} style={style} alt="This is the Logo Image" /> */}

        <a href="/Menu" className="nav">
          <div className="one"></div>
          <div className="two"></div>
          <div className="three"></div>
        </a>

        <div className="hero-section">
          <div className="hero-sub-con1">
            <div className="sub-container1">
              <h1>Your Trusted partner for Business Success.</h1>
              <p> Do trust us with your business operations. Have all the tools needed for growth,success and more, all at the tip of your fingers.</p>
              <button className="btn btn-white"><a className="GS-link" href="/SignUp" >Get Started</a></button>
            </div>
          </div>

          <div className="hero-sub-con2">
            <div className="image">
              <img className="" src={image14} alt="" />
            </div>
          </div>
        </div>

        {/* <div className="Small-Box"></div> */}
        {/* <div className="DB-container"></div> */}

        <div className="Second-session">
          <div className="EBiz">
            <h1 className="EBH">Empower your bussiness with the power of documentation</h1>
            <p className="EBP">Join the businesses whose operations are entrusted in our hands.
               All the tools needed for growth, sucess and more, at the tip of your fingers</p>
            <a className="LearnMore" href="">Learn more</a>
          </div>

          <div className="DBiz">
            <h1 className="DBH">Digitize your business, simplify success</h1>
            <p className="DBP">Join the thousands of bussinesses who trust us to manage their operations.
               You will have all the tools you need to grow and succeed, all in one place.</p>
            <a className="LearnMore" href="">Learn more</a>
          </div>

          <div className="BCF">
            <h1 className="BCH">Bring clarity to your Finances</h1>
            <p className="BCP">Join the thousands of businesses who trust us to manage their operations.
               You will have all the tools you need to grow and succeed, all in one place.</p>
            <a className="LearnMore" href="">Learn more</a>
          </div>

          <div className="DBW">
            <h1 className="DBWH">Do business with the right education</h1>
            <p className="DBWP">Join the thousand of businesses who trust us to manage their operations.
              You will have the tools you need to grow and succeed, all in one place.</p>
            <a className="LearnMore" href="">Learn more</a>
          </div>
        </div>

        <div className="ess">
          <h1 className="AEH"> Access essential resources you need to thrive</h1>
          <p className="AEP">learn, grow and succeed in your business. Discover tips, trick and techniques to make your journey easier.</p>
          <div className="ess-btn-con">
            <button className="Blog-btn"><a className="bwt" href="/Blog">Blog</a></button>
            <button className="Web-btn"><a className="bwt2" href="">Webinars</a></button>
          </div>
        </div>

        <div className="WOS-Container">
          <h1 className="WOS">Words on the street</h1>
          <p className="WOSP">Join the chorus of success. Discover the postive impact our customers are raving about.</p>

          <div className="Profile-Container">
            <div className="profile1">
              <img className="profile-image" src={SONIA} alt="" />
              <p className="profile-text">I said goodbye to manual bookkeeping.
                My financial management system was transformed and I was able to access loans easier</p>
              <p className="profile-Name">Sonia Samari</p>
            </div>

            <div className="profile2">
              <img className="profile-image" src={image7} alt="" />
              <p className="profile-text">I said goodbye to manual bookkeeping.
               My financial management system was transformed and I was able to access loans easier</p>
              <p className="profile-Name">Moyo Chigoziem</p>
            </div>

            <div className="profile3">
              <img className="profile-image" src={image3} alt="" />
              <p className="profile-text">I said goodbye to manual bookkeeping.
                My financial management system was transformed and I was able to access loans easier</p>
              <p className="profile-Name">Adenike Youth</p>
            </div>
          </div>
        </div>

        <div className="next-level">
          <h1 className="TAB">Take your business to the next level</h1>
          <p className="TAP">Subscribe to our mailing list to gain expert insights nd solid advice to ful your growth</p>
          <input type="email" id="email-T" name="email" placeholder="Enter your email address" />
          <button className="Submit-btn"><a className="Sub-btn" href="#">Submit</a></button>
        </div>

        <div className="CAP-Container">
          <h1 className="CAP">Choose a plan</h1>
          <p className="CAPP">Pick one that fits your business need</p>

          <div className="Card-Container">

            <div className="BP">
              <div className="BP-CON">
                <h2>Basic Plan</h2>
                <span>Free</span>
              </div>
              <p className="GS">Get a free store front, record sales and access to a our resources and community etc.</p>
              <a className="GB-link" href="/SignUp">Get Started</a>
            </div>

            <div className="GP">
              <div className="BP-CON">
                <h2>Gold Plan</h2>
                <h2 className="amount">#2000/month</h2>
              </div>
              <p className="GS">Get a free store front, record sales and access to a our resources and community etc.</p>
              <a className="GB-link" href="/SignUp">Get Started </a>
            </div>

            <div className="PP">
              <div className="BP-CON">
                <h2>Platinium Plan</h2>
                <h2 className="amount" >#5000/month</h2>
              </div>
              <p className="GS">Get a free store front, record sales and access to a our resources and community etc.</p>
              <a className="GB-link" href="/SignUp">Get Started</a>
            </div>
          </div>
        </div>

        <div className="Partner-container">
          <h1 className="OP">Our partners</h1>

          <div className="Patners-Img-Con">
            <img className="flutterwave" src={image17} alt="" />
            <img className="paystack" src={image18} alt="" />
            <img className="TechC" src={image19} alt="" />
            <img className="Instagram" src={image16} alt="" />
            <img className="spotify" src={image15} alt="" />
            <img className="stripe" src={image20} alt="" />
          </div>

        </div>

        <Footer />
      </div>

    </>
  )
}

export default Home
